import { App } from 'antd';
import type React from 'react';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { CustomEventType } from '../@types/CustomEventType';
import { useAppStore } from '../hooks/store/useAppStore';
import { useCurrentContextStore } from '../hooks/store/useCurrentContextStore.ts';
import { useDoctorHasAis } from '../hooks/useDoctorHasAis';
import { aisImport } from '../utils/aisImport';
import { hasFrontDeskRole } from '../utils/user.ts';

export const ImportFileWatcher: React.FC = () => {
  const auth = useAuth();
  const { message } = App.useApp();

  const setTempAisImportResult = useAppStore(state => state.setTempAisImportResult);

  const { currentDoctorId, primaryDoctorId } = useCurrentContextStore();
  const hasAis = useDoctorHasAis(hasFrontDeskRole(auth.user) ? primaryDoctorId : currentDoctorId);

  useEffect(() => {
    if (!window.nativeApi) {
      return;
    }

    if (!hasAis) {
      console.log('unregistering watcher');
      window.nativeApi.unwatchImportFile();
      return;
    }

    console.log('registering watcher');
    window.nativeApi.watchImportFile(async () => {
      // the desktop api allows exactly one registered listener, so we simply broadcast the event here
      document.dispatchEvent(new Event(CustomEventType.AIS_IMPORT_FILE_CHANGE));

      try {
        const result = await aisImport(auth.user?.access_token ?? '', hasFrontDeskRole(auth.user) ? primaryDoctorId : currentDoctorId);

        setTempAisImportResult(result);
        window.nativeApi?.bringToFront();
      } catch (e) {
        if (e instanceof Error) {
          message.error(e.message);
          return;
        }
        if (e instanceof String) {
          message.error(e);
        }
      }
    });
  }, [primaryDoctorId, auth, hasAis, currentDoctorId, setTempAisImportResult, message]);

  return null;
};
